export default __webpack_public_path__ + "be9ee23c0c6390141475d519c2c5fb8f.ttf";